import { googleTagManagerConfig } from '../../../config/googleTagManagerConfig';
import { isProdEnvironment } from '../../../interfaces/environment/Environment';
import { getWindow } from '../../../services/windowService';
import { callIfFunction } from '../../../utils/callIfFunction';

const wnd = getWindow();

export const GTM_SCRIPT_TAG_ID = 'google-tag-manager';
const traffic_type = isProdEnvironment() ? undefined : 'internal';

export const ensureGTMScriptAdded = (callback?: (value: boolean) => void) => {
  if (document.getElementById(GTM_SCRIPT_TAG_ID)) {
    callIfFunction(callback, true);
    return;
  }
  if (!googleTagManagerConfig.gtmMeasurementId) {
    callIfFunction(callback, false);
    return;
  }
  const script = document.createElement('script');
  script.id = GTM_SCRIPT_TAG_ID;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${googleTagManagerConfig.gtmMeasurementId}`;
  script.async = true;
  script.onload = () => {
    setTimeout(() => {
      wnd.dataLayer = wnd.dataLayer || [];
      wnd.gtag = wnd.gtag = function () {
        wnd.dataLayer.push(arguments);
      };
      wnd.gtag('js', new Date());
      const opts: Record<string, any> = {
        send_page_view: false,
        traffic_type,
      };
      wnd.gtag('config', googleTagManagerConfig.gtmMeasurementId, opts);
      console.log(
        `GTM enabled for "${googleTagManagerConfig.gtmMeasurementId}": ${JSON.stringify(opts)}`,
      );
      callIfFunction(callback, true);
    }, 0);
  };
  document.body.appendChild(script);
};
